import BgNsSelector from '@britishgasenergy/react-nucleus/dist/nuc-components/NsSelector';
import NsColumn from '@britishgasenergy/react-nucleus/dist/nuc-components/NsColumn';
import { NsColumnProps } from '@britishgasenergy/react-nucleus/dist/nuc-components/NsColumn/NsColumn';

import { NsInput } from 'components/common/ns-input/NsInput';
import { NsInputter } from 'components/common/ns-inputter/NsInputter';
import NsInputterEvent from 'components/common/ns-inputter/NsInputterEvent';
import { NsInputterValidations } from 'components/common/ns-inputter/NsInputterValidations';

export const testId = 'rateTypeOptionsTestId';

type Option = {
  value: string;
  title: string;
  description?: string;
};

type NsSelectorProps = {
  heading?: string;
  options: Option[];
  inputType?: 'radio' | 'checkbox';
  validation?: string[];
  value?: string;
  name?: string;
  onChange?: (event: NsInputterEvent) => void;
  dataTestId?: string;
  decoration?: string;
  image?: string;
  keyline?:
    | 'cyan'
    | 'lime'
    | 'navy'
    | 'blue'
    | 'forest'
    | 'slate'
    | 'orange'
    | 'red'
    | 'yellow';
  selectedValue?: string;
  columns?: Omit<NsColumnProps, 'children'>;
};

export const NsSelector = ({
  heading,
  options,
  selectedValue,
  inputType = 'radio',
  name,
  onChange,
  decoration,
  image,
  keyline,
  validation = [NsInputterValidations.isRequired],
  columns = {
    basketballcourt: '2',
    hockeypitch: '2',
    footballpitch: '2',
    rugbypitch: '2',
    polofield: '2'
  }
}: NsSelectorProps) => {
  return (
    <NsInputter
      heading={heading}
      name={name}
      validation={validation}
      onChange={onChange}
      value={selectedValue || ''}
    >
      <NsColumn {...columns}>
        {options.map(({ value, title, description }) => {
          const uniqueIdentifier = `${name}-${value}`
            .replace(/\s/g, '-')
            .toLocaleLowerCase();
          return (
            <BgNsSelector
              decoration={decoration}
              image={image}
              keyline={keyline}
              checked={(value === selectedValue).toString()}
              value={value}
              key={uniqueIdentifier}
            >
              <NsInput
                type={inputType}
                id={uniqueIdentifier}
                name={name}
                value={value}
                label={title}
              />
              {description && <div slot="description">{description}</div>}
            </BgNsSelector>
          );
        })}
      </NsColumn>
    </NsInputter>
  );
};
